import { gql } from "@apollo/client";

//To upload image in library 
export const UPLOAD_LIBRARY_IMAGE=gql`
mutation uploadMylibraryImagesPodcasts($cId: UUID!, $filename: String!, $filepath: String!, $filesize: BigInt!, $isClassroom: Boolean!, $lId: UUID!, $sjId: UUID!, $coverImagePath: String = null, $fileDescription: String = null) {
  uploadMylibraryImagesAndPodcasts(
    input: {pClassroomId: $cId, pFilename: $filename, pFilepath: $filepath, pFilesize: $filesize, pIsClassroom: $isClassroom, pLId: $lId, pSubjectId: $sjId, pCoverImagePath: $coverImagePath, pFileDescription: $fileDescription}
  ) {
    clientMutationId
  }
}`;

//To view all images in library
export const VIEW_ALL_LIBRARY_IMAGES=gql`
query getmyLibraryImagesPodcastsInfo($lId: UUID!, $sjId: UUID!, $cId: UUID!, $limit: Int = null, $offset: Int = null, $searchInput: String = "%", $isClassroom: [Boolean!] = [true, false]) {
  getMylibraryImagesPodcastsInfo(
    pClassroomId: $cId
    pSubjectId: $sjId
    pLId: $lId
    first: $limit
    offset: $offset
    filter: {filename: {likeInsensitive: $searchInput}, isClassroom: {in: $isClassroom}}
  ) {
    nodes {
      filename
      filepath
      isclassroom: isClassroom
      filesize
      fileDescription
      coverImagePath
      fileId
      feedId
    }
    totalCount
  }
}`;

export const UPDATE_IMAGES_PODCASTS = gql`
mutation updateImagesPodcasts($cId: UUID!, $fId: UUID!, $isClassroom: Boolean!, $lId: UUID!, $sjId: UUID!) {
  updateImagesPodcastMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pIsClassroom: $isClassroom, pLibraryId: $lId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;

export const DELETE_IMAGES_PODCASTS = gql`
mutation deleteImagesPodcasts($cId: UUID!, $fId: UUID!, $lId: UUID!, $sjId: UUID!) {
  deleteImagesAndPodcasts(
    input: {pClassroomId: $cId, pFileId: $fId, pLibraryId: $lId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;
